_ = require 'underscore'
React = require 'react'
ReactDOM = require 'react-dom'
Auth = require 'app/scripts/db/auth'
BoardSidebarPowerUpSlotView = require 'app/scripts/views/board-menu/board-sidebar-power-up-slot-view'
Controller = require 'app/scripts/controller'
{ dontUpsell } = require '@trello/config'
MemberState = require 'app/scripts/view-models/member-state'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
Promise = require 'bluebird'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_power_up_slot')
{ BoardSidebarPuPUpsell } = require './BoardSidebarPuPUpsell'
{ renderUpgradePrompt } = require 'app/src/components/UpgradePrompts/renderUpgradePrompt'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ Noun, Verb, trackUe } = require '@trello/analytics'
{ IconName } = require 'app/common/components/controls'
l = require 'app/scripts/lib/localize'

emptySlotUpsell = t.renderable ->
  t.li '.board-menu-navigation-item.mod-power-up-slot.js-empty-slot-upsell'

emptySlot = t.renderable ({ index }) ->
  t.li '.board-menu-navigation-item.mod-power-up-slot', ->
    t.a '.board-menu-navigation-item-link.js-power-up-empty-slot', { href: '#' }, ->
      t.span '.board-menu-navigation-item-link-icon', ->
        if index? then t.text index
      t.raw '&nbsp;'
      t.format 'add-power-up'

template = t.renderable ->
  t.ul '.board-menu-navigation.js-power-up-slots'
  t.ul '.board-menu-navigation.js-upsell-slots'
  t.ul '.board-menu-navigation', ->
    t.li '.board-menu-navigation-item.mod-power-up-slot.js-show-fewer.hide', ->
      t.a '.board-menu-navigation-item-link', { href: '#' }, ->
        t.raw '&nbsp;'
        t.format 'show-fewer-power-ups'
    t.li '.board-menu-navigation-item.mod-power-up-slot.js-show-more.hide', ->
      t.a '.board-menu-navigation-item-link', { href: '#' }, ->
        t.raw '&nbsp;'
        t.format 'view-all-power-ups'

module.exports = class BoardSidebarPowerUpSlotsView extends View

  events:
    'click .js-show-fewer': 'showFewer'
    'click .js-show-more': 'showMore'

  initialize: ->
    @collapsed = false

    @makeDebouncedMethods 'renderPowerUpSlots'

    @listenTo @model,
      'change:idOrganization': @renderPowerUpSlotsDebounced

    @listenTo @model.boardPluginList,
      'add remove reset': (e) =>
        @renderPowerUpSlotsDebounced()

    @subscribe pluginsChangedSignal(@model), =>
      @renderPowerUpSlotsDebounced()

    @listenTo MemberState,
      'change:idBoardCollapsedPowerUps': @renderPowerUpSlotsDebounced

  remove: ->
    @unmountPupPrompt?()
    super

  showFewer: (e) ->
    Util.stop(e)
    trackUe(Noun.BOARD_VIEW, Verb.HIDES, 'Power-Up sidebar slots', '', '', 'by clicking the show fewer Power-ups button')
    MemberState.pushBoardCollapsedPowerUps(@model.id)

  showMore: (e) ->
    Util.stop(e)
    trackUe(Noun.BOARD_VIEW, Verb.SHOWS, 'Power-Up sidebar slots', '', '', 'by clicking the view all Power-ups button')
    MemberState.pullBoardCollapsedPowerUps(@model.id)

  isCollapsed: ->
    MemberState.inSet('idBoardCollapsedPowerUps', @model.id)

  renderPowerUpSlots: ->
    collapsed = @isCollapsed()

    boardPlugins = @model.boardPluginList.models
    if @model.isButlerCore()
      boardPlugins = boardPlugins.filter (boardPlugin) =>
        !boardPlugin.isButler()

    Promise.map boardPlugins, (boardPlugin) =>
      PluginRunner.getOrLoadPlugin(@model, boardPlugin.get('idPlugin'))
    .map (plugin) =>
      @subview(BoardSidebarPowerUpSlotView, @model, {
        plugin
        currentPage: 'board view'
      }, plugin.id)
    .then (subviews) =>
      subviewsToRender = subviews

      if collapsed & subviews.length > 3
        subviewsToRender = _.first(subviews, 3)

      @ensureSubviews(subviewsToRender, @$('.js-power-up-slots'))
    .finally =>
      $powerUpSlotUpsellContainer = @$('.js-upsell-slots')
      @unmountPupPrompt?()
      $powerUpSlotUpsellContainer.empty()

      powerUpsCount = @model.powerUpsCount()

      isShowFewerVisible = powerUpsCount > 3 && !collapsed
      @$('.js-show-fewer').toggleClass('hide', !isShowFewerVisible)

      isShowMoreVisible = powerUpsCount > 3 && collapsed
      @$('.js-show-more').toggleClass('hide', !isShowMoreVisible)

      me = Auth.me()
      org = @model.getOrganization()
      isPremium = org?.isPremium() ? false

      if @model.canEnableAdditionalPowerUps()
        numberOfEmptySlots = 1
        powerUpsLimit = me.getPowerUpsLimit()

        if me.isFeatureEnabled('threePlugins')
          numberOfEmptySlots = 3 - powerUpsCount

        if me.hasBCPowerUps()
          if powerUpsCount < 3
            numberOfEmptySlots = 3 - powerUpsCount
          else
            numberOfEmptySlots = 1

        _.times numberOfEmptySlots, (i) ->
          $powerUpSlotUpsellContainer.append(emptySlot({
            index: if isPremium then undefined else (i + 1) + powerUpsCount
          }))

      billingUrl = if org then Controller.getOrganizationBillingUrl(org)
      $powerUpSlotUpsellContainer.append(emptySlotUpsell())

      @unmountPupPrompt = renderUpgradePrompt(
        React.createElement(BoardSidebarPuPUpsell, { billingUrl })
        , $powerUpSlotUpsellContainer.find('.js-empty-slot-upsell')[0]
        , {
          boardModel: @model
        }
      )

  render: ->
    @$el.html template()
    @renderPowerUpSlots()
    @
